import React from 'react';
import ReactDOM from 'react-dom';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';

//Styles

import '../styles/chapter_two.scss';
import '../styles/video.scss';
import '../styles/transition-group.scss';


import QuizData from './chapter2/quizData.js';
import Iconset from './icons';

//Components
import Pause_menu from './pause_menu';

import Shareelement from './shareelement';
import Warenkorb from './warenkorb_menu';

import Timeline from './chapter2/chapter_two_timeline';
import Quiz from './chapter2/quiz';

import Intro from './chapter2/chapter_two_intro';
import FastVideo from './chapter2/chapter_two_fast_video';


class Chapter_Two extends React.Component{
	constructor(props){
		super(props);
		this.state = {
			currentPercentage : 0,
			currentInnerChapter : 0,
			currentInnerChapterTime : 0,
			question : 1,
			isPlaying : !_assets.isMobile,

			timelineVisible : true,
			isWaiting : false,

			timeforUserQuiz : false,
			timeforInterview : false,
			timeforEvaluation : false,
			showIntro : true, 
			showQuiz : false,
			//slideshow
			showSlideshowLogin : false,
			showSlideshow : false,
			slideshowWasVisible : false,
			selectedQuestion : false,
			selectedQuestions : [],
			questionStack : [],
			selectedInterviewQuestion : [],
			timeforThankYou : false,
			userAnswers : [],
			alreadyAskedQuestions : [],
			showPWIndicator : false
		}

		this.internalQuizData = QuizData.slice(0);

	}

	componentDidMount(){
		}




	play(){
		this.setState({
			isPlaying : true
		},function(){
			setTimeout(function(){
				if(!this.state.showIntro){
					this.setState({
						timeforInterview : false
					});
				}
			}.bind(this),500)
		});
	}
	pause(){
		this.setState({
			isPlaying : false
		});
	}

	goToInnerChapter(event){
		event.preventDefault();
		event.stopPropagation();

		this.goToInnerChapterByName(parseFloat(event.target.dataset.name));
		
	}

	goToInnerChapterByName(iWantChapter){
		//console.log('goToInnerChapterByName');

		this.setState({
			currentInnerChapter : iWantChapter,
			currentInnerChapterTime : 0,
			showIntro : true,
			isPlaying : true,
			timeforUserQuiz:false,
			timeforInterview:true,
			timeforEvaluation:false,
		});
	}

	changeInnerChapter(){
		//console.log('changeInnerChapter')
		let currentChapter = this.state.currentInnerChapter;
		currentChapter++;

		this.setState({
			currentInnerChapter : currentChapter,
			currentInnerChapterTime : 0,
			isPlaying : true,
			currentVideoTimePercentage : 0
		});
	}

	ended(){
		//console.log('ende', this.state.currentInnerChapter);
		if(this.state.currentInnerChapter != 2){
			this.changeInnerChapter();
		}
	}

	changeInterview(cb){

		//console.log('changeInterview');

		this.setState({
			timeforUserQuiz: false,
			question : this.state.question + 1,

		},function(){
			if(this.state.question === 6){
				//console.log('ende',this.state.question);
				this.setState({
					timeforEvaluation : true
				})
			}else{
				cb();
				this.setState({
					timeforInterview : true
				});
			}
		});
	}
	//_______________________________________________ 
	shuffleArray(array) {
    for (var i = array.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
	}


	getRandomQuizQuestion(){
		//last Question

		var randNum = Math.floor( Math.random() * 3 );
		//take already selected question
		if(typeof this.state.alreadyAskedQuestions[this.state.question-1] != "undefined"){
			//console.log("show stacked Questions ", this.state.alreadyAskedQuestions[this.state.question-1].questions );
			this.setState({
				selectedUserQuestion : randNum,
				currentVideoTimePercentage : 0,
				selectedInterviewQuestion: this.state.alreadyAskedQuestions[this.state.question-1].questions
			});
		}else{
			//select two new random questions
			this.shuffleArray(this.internalQuizData);
			this.setState({
				selectedUserQuestion : randNum,
				currentVideoTimePercentage : 0,
				selectedInterviewQuestion: [this.internalQuizData[0],this.internalQuizData[1]],
				alreadyAskedQuestions : this.state.alreadyAskedQuestions.concat([{"questions" : [this.internalQuizData[0],this.internalQuizData[1] ]}])
			},function(){
				this.internalQuizData.splice(0,2);
				this.setTimeLineQuestions(this.state.alreadyAskedQuestions);

				//console.log("show new Questions ", this.state.selectedInterviewQuestion);
			});
		}
	}


	selectQuestion(event,frage){
		//must set selectedQuestion to false
		//before setting it again to swap video
		this.setState({
			selectedQuestion : false
		},function(){

			this.setState({
				selectedQuestion : frage,
				isWaiting : true,
			},function(){
				this.play();
			});
		});
	}


	addUserAnswer(evaluatedAnswer){

		let privateUserAnswers = this.state.userAnswers.slice(0);

		privateUserAnswers[this.state.question - 1] = evaluatedAnswer;

		this.setState({
			userAnswers : privateUserAnswers
		},function(){

			setTimeout(function(){	
				this.changeInterview(()=>{
					this.getRandomQuizQuestion();
				});
			}.bind(this),3000);

		});
	}

	setTimeLineQuestions(questions){
		this.setState({
			currentVideoTimePercentage : 0,
			selectedQuestions : questions
		});
	}


	goToSpecificQuestion(event){
		event.preventDefault();

		if(this.state.currentInnerChapter == 2 && (typeof this.quizElement.videoRef != "undefined")){
			//reset video
  		this.quizElement.videoRef.video.currentTime = 0;
		}
		let goToQuestion = parseFloat(event.target.dataset.question);
		//console.log(event.target.dataset.question);
		if(goToQuestion==0){
			//console.log('goToQuestion', 0);
			this.setState({
			 	question : goToQuestion +1,
			 	currentInnerChapter : 2,
			 	timeforInterview : true,
			 	timeforEvaluation : false,
			 	timeforSlideshow : false,
			 	timeforUserQuiz : false,
			 	showIntro : true,
			 	showQuiz : false,
			 	isPlaying : false,
			 	currentInnerChapterTime :0,
			 	currentPercentage : 0,
			 	selectedInterviewQuestion : this.state.selectedQuestions[goToQuestion].questions
			});
		}else{
			this.setState({
			 	question : goToQuestion +1,
			 	currentInnerChapter : 2,
			 	timeforInterview : true,
			 	timeforEvaluation : false,
			 	timeforSlideshow : false,
			 	timeforUserQuiz : false,
			 	showIntro : false,
			 	isPlaying : false,
			 	currentInnerChapterTime :0,
			 	currentPercentage : 0,
			 	selectedInterviewQuestion : this.state.selectedQuestions[goToQuestion].questions
			});
		}
	}


	showThankYou(){

		this.setState({
		 	timeforEvaluation : false,
		 	timeforThankYou : true,
		 	isPlaying : false,
		});

	}


	//_______________________________________________ 
	disableQuizIntro(){
		//setTimeout(()=>{
			this.setState({
				showIntro : false,
				timeforInterview : true
			},function(){
				setTimeout(()=>{
					this.setState({
						showQuiz : true
					})
				},500);
			});
		//},5000);
	}


	isWaiting(){

		this.setState({
			isWaiting : true
		})
		//console.log('chapter2 is waiting');
	}

	isNotWaiting(){
		this.setState({
			isWaiting : false
		});
	}


	timeupdate(video){
		this.isNotWaiting();
		this.setState({
			currentInnerChapterTime : video.currentTime,
			currentVideoTimePercentage : (video.currentTime * 100 / video.duration).toFixed(0)
		});

		let timeleft = video.duration - video.currentTime;


		if(this.state.currentInnerChapter == 2 && !this.state.showIntro){
			//show slideshow
			if(this.state.question == 3 && this.state.currentInnerChapterTime > 20 && timeleft > 2 && !this.state.slideshowWasVisible){
				this.setState({
					showSlideshowLogin : true,
					showPWIndicator : true,
				});
			}else{
				this.setState({
					showSlideshowLogin : false,
				});
			}

			if(this.state.question != 3){
				this.setState({
					slideshowWasVisible : false,
					showPWIndicator : false,
				});
			}


			if(timeleft < 2){
				this.setState({
					timeforUserQuiz : true
				},function(){
					this.pause();
				});
			}
		}


		//console.log('update',this.state.currentVideoTimePercentage);
	}


	//____________________________________


	hideTimeline(){
		if(_assets.isMobile){
			this.pause();
			this.setState({
				timelineVisible : false
			});
		}
	}

	showTimeline(event){

		if(_assets.isMobile){

			this.setState({
				timelineVisible : true
			});
		}
	}

	showSlideShowAction(){
		this.pause();
		this.setState({
			showPWIndicator : true,
			showSlideshowLogin : false,
			showSlideshow : true,
			slideshowWasVisible : true
		});
	}

	hideSlideShowAction(){
		this.play();
		this.setState({
			showSlideshow : false,
			timelineVisible : true
		});
	}

	updateVideoTimeForFastVideo(updateVideoTimeForFastVideo){
		this.setState({
			currentVideoTimePercentage :	updateVideoTimeForFastVideo
		})
	}


	//____________________________________
	render(){
		
		const pauseBool_Interview = (this.state.timeforInterview && this.state.currentInnerChapter == 2);
		const pauseBool_User = (this.state.timeforUserQuiz && this.state.currentInnerChapter == 2);
		const slideshowBool = (this.state.showSlideshow && this.state.showSlideshow);

		return (
			<div className="chapterContent chapter-2">

		{/* Tooltip Session */}
			<ReactCSSTransitionGroup
				component= "div"
				className="main-tooltip-holder"
			  transitionName="fade"
			  transitionEnterTimeout={500}
			  transitionLeaveTimeout={300}>
			  {( pauseBool_Interview || pauseBool_User || this.state.currentInnerChapter == 1) && 
					<div className="main-tooltip">
						<Iconset.loader />
						{this.state.currentInnerChapter == 1 &&
							<span>Hold space and see what happens</span>
						}
					</div>
				}
				</ReactCSSTransitionGroup>

		{/* Loading Icon */}
			<ReactCSSTransitionGroup
					component= "div"
					className={"is-waiting-holder is-waiting-" + this.state.isWaiting}
			    transitionName="fade"
			    transitionAppear={true}
     			transitionAppearTimeout={500}
			    transitionEnterTimeout={500}
			    transitionLeaveTimeout={300}>
						{this.state.isWaiting &&
							<div className="is-waiting">
								<div className="is-waiting-loading-icon">
									<Iconset.videoLoadingIcon />
								</div>
							</div>
						}
					</ReactCSSTransitionGroup>

				<ReactCSSTransitionGroup
					component= "div"
					className="absolute inner-chapter-holder"
			    transitionName="fade"
			    transitionAppear={true}
     			transitionAppearTimeout={500}
			    transitionEnterTimeout={500}
			    transitionLeaveTimeout={300}>

			  	{/*Chapter Intro*/}	
			    	{this.state.currentInnerChapter == 0 && 
			    			<Intro 
									key={"chapter-" + this.state.currentInnerChapter}
									ended={()=>this.ended()}
									timeupdate={(video)=>this.timeupdate(video)}
									isPlaying={this.state.isPlaying}
									isWaiting={()=>this.isWaiting()}
									play={()=>this.play()}
									pause={()=>this.pause()}
									timecode={this.state.currentInnerChapterTime} />
			    	}
			  		
		  		{/*Chapter FastVideo*/}
		  			{this.state.currentInnerChapter == 1 &&
		  				<FastVideo 
								key={"chapter-" + this.state.currentInnerChapter}
									ended={()=>this.ended()}
									timeupdate={(video)=>this.timeupdate(video)}
									isPlaying={this.state.isPlaying}
									play={()=>this.play()}
									pause={()=>this.pause()}
									isWaiting={()=>this.isWaiting()}
									isNotWaiting={()=>this.isNotWaiting()}
									timecode={this.state.currentInnerChapterTime}
									updateVideoTime={(timecodeInPercentage)=>this.updateVideoTimeForFastVideo(timecodeInPercentage)}
									changeInnerChapter={(toChapter)=>this.goToInnerChapterByName(toChapter)} />
		  			}
		  		{/*Chapter QUIZ*/}
		  			{this.state.currentInnerChapter == 2 &&
		  				<Quiz 
		  					ref={(quizElement)=>this.quizElement = quizElement}
								key={"chapter-" + this.state.currentInnerChapter}
								ended={()=>this.ended()}
								timeupdate={(video)=>this.timeupdate(video)}
								isPlaying={this.state.isPlaying}
								play={()=>this.play()}
								pause={()=>this.pause()}
								isWaiting={()=>this.isWaiting()}
								timecode={this.state.currentInnerChapterTime}
								changeInnerChapter={()=>this.changeInnerChapter()}

								timelineVisible={this.state.timelineVisible}
								showTimeline={(event)=>this.showTimeline(event)}
								hideTimeline={()=>this.hideTimeline()}

								showQuiz={this.state.showQuiz}
								showIntro = {this.state.showIntro}
								disableQuizIntro = {()=>this.disableQuizIntro()}
								timeforUserQuiz={this.state.timeforUserQuiz}
								timeforInterview={this.state.timeforInterview}
								timeforEvaluation={this.state.timeforEvaluation}
								timeforThankYou={this.state.timeforThankYou}
								showThankYou={()=>this.showThankYou()}

								getRandomQuizQuestion = {()=>this.getRandomQuizQuestion()}
								selectedUserQuestion ={this.state.selectedUserQuestion}
								changeInterview={(cb)=>this.changeInterview(cb)}
								question={this.state.question}

								addUserAnswer ={(frage)=>this.addUserAnswer(frage)}
								userAnswers = {this.state.userAnswers}

								selectedQuestion = {this.state.selectedQuestion}
								selectQuestion = {(event,frage)=>this.selectQuestion(event,frage)}
								selectedInterviewQuestion = {this.state.selectedInterviewQuestion}
								goToSpecificQuestion = {(event)=>this.goToSpecificQuestion(event)}

								showSlideshowLogin ={this.state.showSlideshowLogin}
								showSlideshow ={this.state.showSlideshow}
								showSlideShowAction={()=>this.showSlideShowAction()}
								hideSlideShowAction={()=>this.hideSlideShowAction()}
								setTimeLineQuestions={(questions)=>this.setTimeLineQuestions(questions)} />
		  			}

        	</ReactCSSTransitionGroup>

        {/*Pause Menu*/}
        	<ReactCSSTransitionGroup
						component= "div"
						className={"pause-menu-overlay-holder isPlaying-" + this.state.isPlaying + " active-chapter-" + this.state.currentInnerChapter + " timeforInterview-" + this.state.timeforInterview+ " timeforUserQuiz-" + this.state.timeforUserQuiz+ " timeforEvaluation-" + this.state.timeforEvaluation + " timeforSlideshow-" + slideshowBool + " timeforThankYou-"+this.state.timeforThankYou}
			      transitionName="fadeDown"
			      transitionAppear={true}
     				transitionAppearTimeout={500}
			      transitionEnterTimeout={500}
			      transitionLeaveTimeout={300}>
			      	{ (!this.state.isPlaying) && !pauseBool_Interview && !pauseBool_User && !slideshowBool && this.state.timelineVisible && !this.state.timeforThankYou &&
			      		<Pause_menu play={()=>this.play()}
			      		chapter={2}/>
        			}			          
        	</ReactCSSTransitionGroup>
        	
        	{this.state.timelineVisible &&
					  <nav className="main-nav">
							<div className="main-nav-inner">
								{/*<Warenkorb />*/}
								
									<Timeline 
										play={()=>this.play()}
										isPlaying={this.state.isPlaying}
										pause={()=>this.pause()}
										question={this.state.question}
										currentInnerChapter ={this.state.currentInnerChapter}
										currentVideoTimePercentage = {this.state.currentVideoTimePercentage}
										currentInnerChapterTime = {this.state.currentInnerChapterTime}
										goToInnerChapter={this.goToInnerChapter.bind(this)}
										goToSpecificQuestion = {(event)=>this.goToSpecificQuestion(event)}
										selectedQuestions={this.state.selectedQuestions}
										showSlideshowLogin={this.state.showPWIndicator} 

										showIntro = {(this.state.showIntro)}
										timeforInterview = {this.state.timeforInterview}
										timeforUserQuiz ={this.state.timeforUserQuiz} />

										<Shareelement chapter={this.props.chapter}/>
								
							</div>
						</nav>
					}
			</div>);
	}
}



export default Chapter_Two;


// WEBPACK FOOTER //
// ./src/scripts/chapter_two.js